import React from 'react';
import { Loader } from '@mantine/core';

const LoadingIndicator = () => (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Loader size="xl" variant="bars" />
    </div>
);

export default LoadingIndicator;